// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel/channel_produce_permissions.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PeerGroup, peerGroupFromJSON, peerGroupToJSON } from "../peer/peer_group";
import { ProducerLabel, producerLabelFromJSON, producerLabelToJSON } from "../producer/producer_label";

export const protobufPackage = "channel";

export interface ChannelProducePermissions {
  groups: PeerGroup[];
  producePermissions: ProducerLabel[];
  changedProducePermissions: ProducerLabel[];
}

function createBaseChannelProducePermissions(): ChannelProducePermissions {
  return { groups: [], producePermissions: [], changedProducePermissions: [] };
}

export const ChannelProducePermissions: MessageFns<ChannelProducePermissions> = {
  encode(message: ChannelProducePermissions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.groups) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.producePermissions) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.changedProducePermissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelProducePermissions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelProducePermissions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.groups.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.groups.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 16) {
            message.producePermissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.producePermissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 24) {
            message.changedProducePermissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.changedProducePermissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelProducePermissions {
    return {
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => peerGroupFromJSON(e)) : [],
      producePermissions: globalThis.Array.isArray(object?.producePermissions)
        ? object.producePermissions.map((e: any) => producerLabelFromJSON(e))
        : [],
      changedProducePermissions: globalThis.Array.isArray(object?.changedProducePermissions)
        ? object.changedProducePermissions.map((e: any) => producerLabelFromJSON(e))
        : [],
    };
  },

  toJSON(message: ChannelProducePermissions): unknown {
    const obj: any = {};
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => peerGroupToJSON(e));
    }
    if (message.producePermissions?.length) {
      obj.producePermissions = message.producePermissions.map((e) => producerLabelToJSON(e));
    }
    if (message.changedProducePermissions?.length) {
      obj.changedProducePermissions = message.changedProducePermissions.map((e) => producerLabelToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelProducePermissions>, I>>(base?: I): ChannelProducePermissions {
    return ChannelProducePermissions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelProducePermissions>, I>>(object: I): ChannelProducePermissions {
    const message = createBaseChannelProducePermissions();
    message.groups = object.groups?.map((e) => e) || [];
    message.producePermissions = object.producePermissions?.map((e) => e) || [];
    message.changedProducePermissions = object.changedProducePermissions?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
